import { LogLevel } from "@azure/msal-browser";

/**
 * Microsoft Entra External ID (CIAM) configuration for the Bloom EMR tenant.
 *
 * Sign-in is restricted — enforced in the External ID tenant — to:
 *   • Microsoft accounts in the bloombrightllc workforce tenant
 *   • Google accounts in the @hopeshorizon.com Google Workspace
 * New users are invite-only (an admin creates them; they receive an invitation email).
 */
const tenantSubdomain = "bloombrightemr";
const tenantId = "e61174df-3b05-40ce-8f72-1eeba9e97035";
const authorityDomain = `${tenantSubdomain}.ciamlogin.com`;

export const msalConfig = {
  auth: {
    clientId: "c85ba202-1f7f-44b8-83cd-1eaa7481ab4a", // "Bloom EMR Web" SPA app registration
    authority: `https://${authorityDomain}/${tenantId}`,
    knownAuthorities: [authorityDomain],
    redirectUri: "/", // registered SPA redirect URI; defaults to window.location.origin
    postLogoutRedirectUri: "/",
    navigateToLoginRequestUrl: false,
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: true,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            return;
          case LogLevel.Verbose:
            console.debug(message);
            return;
          case LogLevel.Warning:
            console.warn(message);
            return;
          default:
            return;
        }
      },
    },
  },
};

/**
 * The API scope exposed by the "Bloom EMR Web" app registration. The backend validates
 * tokens whose audience is this app and that carry the access_as_user scope.
 */
export const protectedResources = {
  api: {
    scopes: {
      read: ["api://c85ba202-1f7f-44b8-83cd-1eaa7481ab4a/access_as_user"],
    },
  },
};

export const loginRequest = {
  scopes: ["openid", "profile", "offline_access", ...protectedResources.api.scopes.read],
};
